import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button';
import { Hide, Show } from '@atlaskit/primitives/responsive';
import ArrowUpRightIcon from '@atlaskit/icon/core/arrow-up-right';

import { i18n } from './bpqai18n.ts';
import {
	Link,
	ButtonText,
	QuickCardContainer,
	QuickCardIcon,
	QuickCardColumn,
} from './bpqaStyled.tsx';
import { QuickTemplateIcon } from './QuickTemplateIcon.tsx';
import { useBlankPageQuickActionsContext } from './BlankPageQuickActionsContext.tsx';

interface AllTemplatesLinkProps {
	isAllTemplatesLinkActive: boolean;
	handleAllTemplatesClick: () => void;
	disabled: boolean;
}

export const AllTemplatesLink = ({
	isAllTemplatesLinkActive,
	handleAllTemplatesClick,
	disabled,
}: AllTemplatesLinkProps) => {
	const { revampedBpqa } = useBlankPageQuickActionsContext();
	return (
		<>
			<Hide below="xs">
				{/* eslint-disable-next-line @atlassian/a11y/anchor-is-valid */}
				<Link isActive={isAllTemplatesLinkActive}>
					<Button
						testId="blank-page-quick-actions-all-templates-link"
						onClick={handleAllTemplatesClick}
						isDisabled={disabled}
						spacing="compact"
						shouldFitContainer
						iconAfter={
							revampedBpqa ? (
								<ArrowUpRightIcon
									testId="blank-page-quick-actions-all-templates-arrow"
									size="medium"
									label="Open pane"
								/>
							) : undefined
						}
					>
						<ButtonText isDisabled={disabled}>
							<FormattedMessage {...i18n.allTemplates} />
						</ButtonText>
					</Button>
				</Link>
			</Hide>
			<Show below="xs">
				<QuickCardContainer isDisabled={disabled}>
					<Button
						isSelected={isAllTemplatesLinkActive}
						onClick={handleAllTemplatesClick}
						isDisabled={disabled}
						spacing="compact"
						iconBefore={
							<QuickCardIcon isDisabled={disabled}>
								<QuickTemplateIcon blueprintModuleCompleteKey={null} />
							</QuickCardIcon>
						}
					>
						<QuickCardColumn>
							<ButtonText isDisabled={disabled}>
								<FormattedMessage {...i18n.allTemplates} />
							</ButtonText>
						</QuickCardColumn>
					</Button>
				</QuickCardContainer>
			</Show>
		</>
	);
};
